export const ACCOUNT_SUB_TYPE_ALT_TEXT = {
  FLEX_BASIC: "Flex Basic",
  FLEX_ACCOUNT: "Flex Account",
  FLEX_PLUS: "Flex Plus",
  FLEX_DIRECT: "Flex Direct",
  FLEX_ONE: "Flex One",
  FLEX_STUDENT: "Flex Student",
  FLEX_GRADUATE: "Flex Graduate",
};
export const DEBIT_CARD = "Debit Card";
export const ERROR_MESSAGE = {
  HEADING: "Sorry, something has gone wrong",
  SUB_HEADING:
    "There is a technical issue that is not your fault. We are working on fixing it.",
};
export const GAMBLING = "GAMBLING";
export const GAMBLING_CONTROLS = "Gambling controls";
export const INVERSTOR_TYPE_CODE = {
  JOINT_HOLDER: "1",
  SINGLE_HOLDER: "0",
};
export const MESSAGE_HEADING_TYPE = {
  INFORMATION: "Information",
  NOTE: "Note",
};
export const MESSAGE_TYPE = {
  INFO: "info",
  WARNING: "warning",
};
export const PAGE_LOADING = "Page Loading";
export const REQUEST_TYPE = {
  GET: "GET",
  SET: "SET",
};
export const SF_COMMUNICATION = {
  EVENTS: {
    ON_START: "onStart",
    SET_HEIGHT: "setHeight",
    SET_TITLE: "setTitle",
    SET_CONTAINER_CONFIG: "setContainerConfig",
    SHOW_MODAL: "showModal",
  },
  IFRAME_HEIGHT: 400,
  METHODS: {
    ON_START_CALLBACK: "onStart_callback",
    SHOW_MODAL_CALLBACK: "showModal_callback",
  },
};
export const VISA = "Visa";
